import React, { FC } from 'react'

import { UserRequiredFieldsCard } from '../../cards/UserRequiredFieldsCard/UserRequiredFieldsCard'
import { UserProfileCard } from '../../cards/UserProfileCard/UserProfileCard'
import { RidingDetailsCard } from '../../cards/RidingDetailsCard/RidingDetailsCard'
import { UserMembershipsCard } from '../../cards/UserMembershipsCard/UserMembershipsCard'

import { IUserInterface } from '../../../../../../models/users/user.interface'
import { IEventReviewPublish } from '../../../../../../models/event-review-publish/event-review-publish.interface'

interface ProfileTabProps {
  user: IUserInterface | null
  setUser?: (state: IUserInterface) => void
  publishedEvent: IEventReviewPublish | null
}

export const ProfileTab: FC<ProfileTabProps> = ({ user, setUser, publishedEvent }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
      <div className="flex flex-col gap-5">
        <UserRequiredFieldsCard
          user={user}
          setUser={setUser}
          eventRequiredUserFields={publishedEvent?.EventRequiredFields.requiredFields}
          isEditable={true}
        />
      </div>
      <div className="flex flex-col gap-5">
        <UserProfileCard user={user} setUser={setUser} isEditable={true} />
        <RidingDetailsCard user={user} setUser={setUser} isEditable={true} />
        <UserMembershipsCard user={user} setUser={setUser} isEditable={true} />
      </div>
    </div>
  )
}
